/* tslint:disable */
/* eslint-disable */
/**
 * Has Account At MEP
 * API for checking accounts if they are already exist with registered e-mail address
 *
 * The version of the OpenAPI document: _
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    HasAccountAtMepRequest,
    HasAccountAtMepRequestFromJSON,
    HasAccountAtMepRequestToJSON,
    HasAccountAtMepResponse,
    HasAccountAtMepResponseFromJSON,
    HasAccountAtMepResponseToJSON,
} from '../models';

export interface HasAccountAtMepPostRequest {
    hasAccountAtMepRequest: HasAccountAtMepRequest;
}

/**
 * 
 */
export class HasAccountAtMepApi extends runtime.BaseAPI {

    /**
     * Checks accounts if they are already exist with registered e-mail address
     * Checks accounts if they are already exist
     */
    async hasAccountAtMepPostRaw(requestParameters: HasAccountAtMepPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<HasAccountAtMepResponse>> {
        if (requestParameters.hasAccountAtMepRequest === null || requestParameters.hasAccountAtMepRequest === undefined) {
            throw new runtime.RequiredError('hasAccountAtMepRequest','Required parameter requestParameters.hasAccountAtMepRequest was null or undefined when calling hasAccountAtMepPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/has-account-at-mep`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HasAccountAtMepRequestToJSON(requestParameters.hasAccountAtMepRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HasAccountAtMepResponseFromJSON(jsonValue));
    }

    /**
     * Checks accounts if they are already exist with registered e-mail address
     * Checks accounts if they are already exist
     */
    async hasAccountAtMepPost(requestParameters: HasAccountAtMepPostRequest, initOverrides?: RequestInit): Promise<HasAccountAtMepResponse> {
        const response = await this.hasAccountAtMepPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
